import React, { forwardRef } from 'react';
import BaseButton from './BaseButton';

const SearchButton = forwardRef(({ title = 'Search', ...props }, ref) => (
  <BaseButton
    ref={ref}
    id='search-button'
    className='search-button'
    icon='search'
    tooltip={title}
    {...props}
  />
));

export default SearchButton;
